export const itemTranslations = {
    en: {
        // Items
        items: 'Items',
        manageItems: 'Manage Items',
        addItem: 'Add Item',
        editItem: 'Edit Item',
        editItemDescription: 'Update item information and settings',
        searchItems: 'Search Items',
        allItems: 'All Items',
        noItemsFound: 'No items found',
        getStarted: 'Get started by adding your first item',
        nameEnglish: 'Name (English)',
        nameArabic: 'Name (Arabic)',
        descriptionEnglish: 'Description (English)',
        descriptionArabic: 'Description (Arabic)',
        sortOrder: 'Sort Order',
        category: 'Category',
        selectCategory: 'Select Category',
        itemImage: 'Item Image',
        uploadImage: 'Upload Image',
        imageRequirements: 'PNG, JPG up to 10MB',
        backToItems: 'Back to Items',
        createItem: 'Create Item',
        createItemDescription: 'Add a new item to your menu',
        itemCreated: 'Item created successfully',
        errorCreatingItem: 'Error creating item',
        noItemsInCategory: 'No items in this category',
        
        // Messages
        confirmDelete: 'Are you sure you want to delete this item?',
        successDelete: 'Item deleted successfully',
        successSave: 'Changes saved successfully',
        errorSave: 'Error saving changes',
        checkFormErrors: 'Please check the form for errors',
        errorLoadingData: 'Error loading data',
        errorSavingChanges: 'Error saving changes',
        errorDeletingItem: 'Error deleting item',
        errorAddingItem: 'Error adding item',
        confirmDeleteItem: 'Are you sure you want to delete this item?',
        itemDeletedSuccessfully: 'Item deleted successfully',
        failedToDeleteItem: 'Failed to delete item',
        errorUpdatingItem: 'Error updating item'
    },
    ar: {
        // Items
        items: 'المنتجات',
        manageItems: 'إدارة المنتجات',
        addItem: 'إضافة منتج',
        editItem: 'تعديل المنتج',
        editItemDescription: 'تحديث معلومات المنتج وإعداداته',
        searchItems: 'بحث عن المنتجات',
        allItems: 'جميع المنتجات',
        noItemsFound: 'لم يتم العثور على منتجات',
        getStarted: 'ابدأ بإضافة أول منتج',
        nameEnglish: 'الاسم (بالإنجليزية)',
        nameArabic: 'الاسم (بالعربية)',
        descriptionEnglish: 'الوصف (بالإنجليزية)',
        descriptionArabic: 'الوصف (بالعربية)',
        sortOrder: 'ترتيب العرض',
        category: 'القسم',
        selectCategory: 'اختر القسم',
        itemImage: 'صورة المنتج',
        uploadImage: 'رفع صورة',
        imageRequirements: 'PNG, JPG حتى 10MB',
        backToItems: 'العودة إلى المنتجات',
        createItem: 'إضافة منتج',
        createItemDescription: 'إضافة منتج جديد إلى القائمة',
        itemCreated: 'تم إضافة المنتج بنجاح',
        errorCreatingItem: 'حدث خطأ أثناء إضافة المنتج',
        noItemsInCategory: 'لا يوجد أي عناصر في هذا القسم',
        
        // Messages
        confirmDelete: 'هل أنت متأكد من حذف هذا المنتج؟',
        successDelete: 'تم حذف المنتج بنجاح',
        successSave: 'تم حفظ التغييرات بنجاح',
        errorSave: 'خطأ في حفظ التغييرات',
        checkFormErrors: 'يرجى التحقق من الأخطاء في النموذج',
        errorLoadingData: 'خطأ في تحميل البيانات',
        errorSavingChanges: 'خطأ في حفظ التغييرات',
        errorDeletingItem: 'خطأ في حذف المنتج',
        errorAddingItem: 'خطأ في إضافة المنتج',
        confirmDeleteItem: 'هل أنت متأكد من حذف هذا العنصر؟',
        itemDeletedSuccessfully: 'تم حذف العنصر بنجاح',
        failedToDeleteItem: 'فشل في حذف العنصر',
        errorUpdatingItem: 'خطأ في تحديث المنتج'
    }
};
